import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar } from "recharts";

const Stat = ({ label, value, sub, tid }) => (
  <div className="border hairline rounded-xl p-5 bg-white" data-testid={tid}>
    <div className="text-xs uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className="font-serif text-3xl mt-1">{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
  </div>
);

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({data}) => setD(data)); }, []);
  if (!d) return <div>Loading…</div>;

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Overview</div>
        <h1 className="font-serif text-4xl">Dashboard</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat tid="stat-total-sales" label="Total Sales" value={`₹${d.total_sales}`} />
        <Stat tid="stat-today-sales" label="Today's Sales" value={`₹${d.today_sales}`} />
        <Stat tid="stat-total-orders" label="Orders" value={d.orders_total} sub={`${d.orders_today} today`} />
        <Stat tid="stat-customers" label="Customers" value={d.customers} />
        <Stat tid="stat-products" label="Products" value={d.products} />
        <Stat tid="stat-low-stock" label="Low Stock" value={d.low_stock} />
        <Stat tid="stat-out-stock" label="Out of Stock" value={d.out_of_stock} />
        <Stat tid="stat-pending" label="Pending Orders" value={d.by_status?.order_confirmed || 0} />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="border hairline rounded-xl p-5 bg-white">
          <div className="text-sm font-medium mb-3">Sales (last 7 days)</div>
          <div style={{ height: 240 }}>
            <ResponsiveContainer>
              <LineChart data={d.sales_series}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E6DFD3" />
                <XAxis dataKey="date" stroke="#786554" fontSize={11} />
                <YAxis stroke="#786554" fontSize={11} />
                <Tooltip />
                <Line type="monotone" dataKey="amount" stroke="#B8860B" strokeWidth={2} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="border hairline rounded-xl p-5 bg-white">
          <div className="text-sm font-medium mb-3">Top Products</div>
          <div style={{ height: 240 }}>
            <ResponsiveContainer>
              <BarChart data={d.top_products}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E6DFD3" />
                <XAxis dataKey="name" stroke="#786554" fontSize={10} tick={{ transform: "rotate(-8)" }} interval={0} />
                <YAxis stroke="#786554" fontSize={11} />
                <Tooltip />
                <Bar dataKey="sold" fill="#8B5A2B" radius={[6,6,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="border hairline rounded-xl p-5 bg-white">
        <div className="text-sm font-medium mb-3">Recent Orders</div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="recent-orders">
            <thead className="text-left text-xs text-muted-foreground uppercase tracking-widest">
              <tr><th className="py-2">Order</th><th>Date</th><th>Customer</th><th>Total</th><th>Status</th></tr>
            </thead>
            <tbody>
              {d.recent_orders.map((o) => (
                <tr key={o.order_number} className="border-t hairline">
                  <td className="py-2 font-medium">{o.order_number}</td>
                  <td className="text-muted-foreground text-xs">{new Date(o.created_at).toLocaleString()}</td>
                  <td>{o.address?.full_name}</td>
                  <td>₹{o.total}</td>
                  <td><span className="capitalize gold-text">{o.status.replace(/_/g, " ")}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
